<template>
  <div class="top-bar">
    <slot></slot>
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  props: {
    title: String
  }
}
</script>

<style scoped lang="scss">
.top-bar {
  background-color: $primary-dark;
  padding: 6rem 1rem 0;
  height: 10rem;
  color: white;
  text-align: center;
  img {
    height: 2.5rem;
    margin: 0 0.5rem 1rem 0;
  }
  h1 {
    display: inline;
    font-size: $h2-font-size;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .top-bar {
    padding: 10rem 0rem 0;
    height: 16rem;
    img {
      height: 3rem;
      margin: 0 1rem 1rem 0;
    }
    h1 {
      font-size: $h1-font-size;
    }
  }
}
</style>
